module.exports = __webpack_public_path__ + "static/media/main-logo-v2.24f85a16.svg";